import { Link } from "react-scroll";

import bgImage from "../Assets/Images/1.png";

const Header = () => {
    return (
        <header style={{ backgroundImage: `url(${bgImage})`}}> 
            <div className="header-bg" />
            <img src={bgImage} alt="bg img" />
            <div className="header-text">
                <h1>Welcome to Page Partners</h1>
                <p>Where we connect top engineering talent with leading organizations. Our industry expertise enables us to strategically place highly skilled professionals in roles where they can thrive.</p>
                <div className="header-buttons">
                   <Link to="about" smooth={true} duration={500}><button>Discover More</button></Link>
                   <Link to="contact" smooth={true} duration={500}><button className="cnct-btn">Contact Us</button></Link>
                </div>
            </div>
        </header>
    );
}

export default Header;